<kw-wrapper [wrapperClass]="wrapperClass" [bgColor]="bgColor">
    <div class="rich-text-wrapper" [ngClass]="headerSizeClass">
        <kw-grid-cell-wrapper [ngClass]="gridCell.className" [attr.cell-id]="gridCell.cellId" class="grid-cell-container cell-shadow" *ngFor="let gridCell of cells" [gridCell]="gridCell" kweOptionalClasses>
            <div class="content-layer">
                <div class="content-layout" [ngClass]="gridCell.layoutClass">
                    <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                        <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                    </div>
                </div>
            </div>
        </kw-grid-cell-wrapper>
        
    </div>
</kw-wrapper>